import { Question } from './question';

export class Response {
    id: number;
    text: string;
    selected = false;
    freeMessage = "";
    score = 0;
    dropdown?: Array<number>;
    image?: string;
    flavour?: string;
    brand?: string;
    category?: string

    constructor(id: number, text: string, dropdown?: Array<number>, image?: string, flavour?: string, brand?: string, category?: string) {
        this.id = id;
        this.text = text;
        this.dropdown = dropdown;
        this.image = image;
        this.flavour = flavour;
        this.brand = brand;
        this.category = category;
    }

    render(response: Response): boolean {
        return true;
    }

    calculateDropdown(question: Question) {
        if (question.type === 'order') {
            let renderedResponses = question.renderResponse();
            let usedValues = renderedResponses.map(r => r.score).filter(sc => sc > 0);
            let fullDropDownValues = [...Array(renderedResponses.length + 1).keys()];
            fullDropDownValues.splice(0, 1);
            this.dropdown = fullDropDownValues.filter(fV => usedValues.indexOf(fV) < 0);
        } else {
            this.dropdown = [];
        }
        return this.dropdown;
    }
}